import { Message, WebMediaQuery } from '@aperza/ui';
import { AppService } from '@aperza/util';
import PropTypes from 'prop-types';
import React from 'react';
import NavBarItem from './NavBarItem';
const appConfig = AppService.appConfig();
export default class PromoteCompanyLink extends React.Component {
    render() {
        let promoteUrl = `https://www.aperza.com/corp/service/aperzacatalog_guide/`;
        let largeDesktopOnly = true;
        let messageId = 'navbar.promote.company';
        if (appConfig.isAperzaMarketplace || !this.props.disableMarketplaceBanner) {
            promoteUrl = `https://www.aperza.com/corp/service/aperza_sellers/`;
            largeDesktopOnly = false;
            messageId = 'navbar.promote.company_ec';
        }
        return (React.createElement(WebMediaQuery, { largeDesktopOnly: largeDesktopOnly },
            React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: messageId }), openOnNewTab: true, url: promoteUrl })));
    }
}
PromoteCompanyLink.propTypes = {
    viewer: PropTypes.shape({
        disableMarketplaceBanner: PropTypes.bool,
    }),
};
